import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Protects admin routes: requires auth; redirects super_admin away from /dashboard, tenant_admin away from /super-admin.
 */
function ProtectedRoute({ children, requireSuperAdmin, requireTenantAdmin }) {
  const { user, loading, role } = useAuth();
  const location = useLocation();
  const path = location.pathname;

  if (loading) {
    return (
      <div className="dashboard-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="super-admin-loading">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/adminlogin" state={{ from: path }} replace />;
  }

  if (requireSuperAdmin && role !== 'super_admin') {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireTenantAdmin && role !== 'tenant_admin') {
    return <Navigate to="/super-admin" replace />;
  }

  // Role-based redirect when no explicit require* is set (e.g. /dashboard and /super-admin)
  if (path.startsWith('/super-admin') && role === 'tenant_admin') {
    return <Navigate to="/dashboard" replace />;
  }
  if (path.startsWith('/dashboard') && role === 'super_admin') {
    return <Navigate to="/super-admin" replace />;
  }
  if (path.startsWith('/memberdetails') && role === 'super_admin') {
    return <Navigate to="/super-admin" replace />;
  }

  return children;
}

export default ProtectedRoute;
